import { useTranslation } from 'react-i18next';
import { useFavouritesQuery, useGetCatalogQuery, useSetFavouriteMutation, useWorkspaceRecordsQuery } from '@platform/state/api';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { mainRecordTypes } from '../shell/mainRecordTypes';
import { RecordsTable } from '../shell/RecordsTable';
import { favouriteItems } from '../shell/recordsTableItems';
import { useWorkspaceMeta } from '../shell/useWorkspaceMeta';
import '../shell/records.css';

/**
 * «Обране» (прототип v4 G:L2663–2687, Головна › Моя робота): записи робочого простору, позначені зірочкою (виконавець — із записів простору),
 * ★ у рядку прибирає запис з обраного.
 */
export function FavouritesPage() {
  const { t } = useTranslation();
  const { ws } = useWorkspaceParams();
  const { workspace } = useWorkspaceMeta(ws);
  const { data } = useFavouritesQuery();
  const { data: catalog } = useGetCatalogQuery({ workspaceId: ws });
  const { data: records } = useWorkspaceRecordsQuery({ ws, types: mainRecordTypes(catalog) }, { skip: !catalog || !data?.length });
  const [setFavourite] = useSetFavouriteMutation();
  const items = data ? favouriteItems(data.filter((i) => i.workspaceId === ws), records?.items ?? []) : undefined;
  return (
    <div className="rp-page">
      <div className="rp-head-block">
        <h1>{t('recordsPages.favouritesTitle')}</h1>
        <span className="muted">{t('recordsPages.favouritesSubtitle', { ws: workspace?.name ?? '' })}</span>
      </div>
      <RecordsTable ws={ws} items={items} empty={t('recordsPages.emptyFavourites')} onRemove={(recordId) => void setFavourite({ recordId, on: false })} />
    </div>
  );
}
